import { render, staticRenderFns } from "./Referenzen.vue?vue&type=template&id=85741b56&scoped=true&"
import script from "./Referenzen.vue?vue&type=script&lang=js&"
export * from "./Referenzen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85741b56",
  null
  
)

export default component.exports